// メールテンプレート編集完了
import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { handleBrowserBack } from '../../../BrowserBack';
import { maintenance_type } from '../../../Const';
import Maintenance from '../../../molecules/Maintenance';

const MailTemplateComplete = () => {
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  return (
    <Maintenance active={maintenance_type.mail_templates}>
      <div className="page-title">メールテンプレート編集(完了)</div>
      <div className="complete-message">メールテンプレートの編集が完了しました。</div>
      <div className="footer-btn">
        <a
          href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/mail_template`}
          className="btn btn-mini btn-success"
        >
          次へ
        </a>
      </div>
    </Maintenance>
  );
};

if (document.getElementById('mail-template-complete')) {
  render(<MailTemplateComplete />, document.getElementById('mail-template-complete'));
}
